import React, { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import { Router, Switch, Route } from 'react-router-dom';

import { getItem, KEYS } from '@app/cache';
import GlobalStyle from '@styles/globalStyles';
import routes from '@routes';

import ProtectedRoute from '@components/ProtectedRoute';
import AuthRoute from '@components/AuthRoute';
import ToastWrapper from '@components/Toast';
import Downloader from '@components/Downloader';
import 'react-toastify/dist/ReactToastify.css';
import { history } from '@app/history';

import Base from '@containers/Base';
import AlbumPage from '@containers/AlbumPage';
import LabelPage from '@containers/LabelPage';
import SignInPage from '@containers/SignInPage';
import TracksHistoryPage from '@containers/TracksHistoryPage';
import NotFound from '@containers/NotFound';

const App = inject(
  'authStore',
  'musicStore',
)(
  observer(({ authStore, musicStore: { downloading, downloadProgress } }) => {
    useEffect(() => {
      if (getItem(KEYS.AUTH_TOKEN)) {
        authStore.signInWithSession(getItem(KEYS.AUTH_TOKEN));
      } else {
        authStore.initialize();
      }
    }, []);

    if (!authStore.initialized) return null;

    return (
      <>
        <GlobalStyle />
        <Router history={history}>
          <Switch>
            <ProtectedRoute
              exact
              path={routes.tracksHistory}
              component={TracksHistoryPage}
            />
            <ProtectedRoute exact path={routes.base} component={Base} />
            <ProtectedRoute exact path={routes.album()} component={AlbumPage} />
            <ProtectedRoute exact path={routes.labels} component={LabelPage} />
            <ProtectedRoute exact path={routes.label()} component={LabelPage} />
            <AuthRoute exact path={routes.auth.signIn} component={SignInPage} />
            <Route from="*" component={NotFound} />
          </Switch>
        </Router>
        <Downloader visible={downloading} progress={downloadProgress} />
        <ToastWrapper />
      </>
    );
  }),
);

export default App;
